(function() {
  'use strict';

  var threshold = 0.15; // % de l'élément visible pour déclencher

  if (!('IntersectionObserver' in window)) {
    // Fallback : tout afficher directement
    document.querySelectorAll('[data-nz-reveal]').forEach(function(el) {
      el.classList.add('nz-revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('nz-revealed');
        observer.unobserve(entry.target); // une seule fois
      }
    });
  }, {
    threshold: threshold,
    rootMargin: '0px 0px -40px 0px'
  });

  function init() {
    document.querySelectorAll('[data-nz-reveal]').forEach(function(el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
